
import React, { useState } from 'react';
import { toast } from "@/components/ui/use-toast";
import ShareOptionsGrid from './ShareOptionsGrid';
import CopyLinkButton from './CopyLinkButton';

interface ShareContentProps {
  title: string;
  url: string;
}

const ShareContent: React.FC<ShareContentProps> = ({ title, url }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url).then(() => {
      setIsCopied(true);
      toast({
        title: "Link kopiert",
        description: "Link in die Zwischenablage kopiert",
      });
      setTimeout(() => setIsCopied(false), 2000);
    });
  };

  return (
    <div className="flex flex-col gap-2 animate-in fade-in-50 zoom-in-95 duration-200" role="menu">
      <h3 className="text-sm font-medium mb-2">Artikel teilen</h3>
      <ShareOptionsGrid title={title} url={url} />
      <CopyLinkButton onCopy={handleCopyLink} isCopied={isCopied} />
    </div>
  );
};

export default ShareContent;
